import { type ReactNode } from "react";

import { useShellLayout } from "../context";
import { cx } from "../cx";
import { useAnimTick } from "../hooks/useAnimTick";

interface RootProps {
  "aria-label": string;
  children?: ReactNode;
}

export const Root = ({
  children,
  "aria-label": ariaLabel,
}: Readonly<RootProps>) => {
  const { isRightSidebarVisible: isVisible, rightSidebarWidth: storedWidth } =
    useShellLayout();
  const computedWidth = isVisible ? storedWidth : 0;

  const { isAnimating, endAnimation } = useAnimTick(isVisible);

  return (
    <div
      // inline style: computedWidth is a drag-resized runtime value, not a static Tailwind class
      style={{ width: computedWidth, minWidth: computedWidth }}
      className={cx(
        "shrink-0 overflow-hidden",
        isAnimating && "transition-[width,min-width]",
      )}
      onTransitionEnd={e => {
        if (e.currentTarget === e.target && e.propertyName === "width")
          endAnimation();
      }}
    >
      <aside
        data-testid="circle-ai-shell-panel-root"
        aria-label={ariaLabel}
        aria-hidden={!isVisible || undefined}
        className="border-primary flex size-full min-h-0 flex-col overflow-hidden border-l"
      >
        {isVisible || isAnimating ? children : null}
      </aside>
    </div>
  );
};

Root.displayName = "CircleAIAppShell.Layout.Panel";
